<template>
  <span class="authed-shell">
    <app-sidebar
      :mobile-open="sidebarMobileOpen"
      @close-mobile="closeMobileSidebar"
    />
    <div class="authed-main">
      <navbar @open-sidebar="openMobileSidebar" />
      <ribbon />
      <div
        class="container-fluid main-container"
        :class="additionalFooterClass"
      >
        <!-- Keyed on Oliver's citation counter, which never moves during ordinary
             navigation. A cited record can reuse the route component already on screen,
             and those components read their id in `created`, so without this the URL
             changes and the content does not. -->
        <router-view :key="oliverCitationNav" />
      </div>
      <FloatingMenu />
      <floating-chat-bot-v2 v-if="isAssistantEnabled" />
      <conversation-list v-if="authorizedUser" />
      <footer-view />
      <floating-upload-manager />
    </div>
  </span>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { initializeGleap } from "@/utils/gleap";
import {
  CLINIC_THEME_SYNC,
  activeTheme,
  applyTheme,
  dispatchThemeChanged,
  isClinicThemeId,
  readStoredTheme,
  syncStoredClinicTheme,
} from "@/utils/theme";
import AppSidebar from "../components/AppSidebar.vue";
import FloatingMenu from "../components/FloatingMenu.vue";
import ConversationList from "../components/chat/ConversationList.vue";
import { initiateEcho } from "../utils/echo.js";
import FloatingUploadManager from "../components/FloatingUploadManager.vue";
import FloatingChatBotV2 from "@/components/OliverBotV2/FloatingChatBotV2.vue";

export default {
  name: "Authed",
  components: {
    AppSidebar,
    FloatingMenu,
    ConversationList,
    FloatingUploadManager,
    FloatingChatBotV2,
  },
  data() {
    return {
      sidebarMobileOpen: false,
    };
  },
  created() {
    initializeGleap(this.$?.appContext?.app || this.$root);
    initiateEcho();
    this.getPublicSettings();
    this.resolveThemeOnBoot();
  },
  computed: {
    ...mapState({
      authorizedUser: (state) => state.auth.user,
    }),
    additionalFooterClass: function () {
      return `${(this.$route.name || "").replace(/\./g, "-")}-main-container`;
    },
    isAssistantEnabled() {
      return this.authorizedUser?.features?.assistant;
    },
    oliverCitationNav() {
      return this.$store.state.oliverChatBotV2.citationNavigations;
    },
  },
  methods: {
    ...mapActions({
      getPublicSettings: "settings/getPublicSettings",
      getThemeSettings: "settings/getThemeSettings",
    }),
    async resolveThemeOnBoot() {
      const stored = readStoredTheme();
      if (stored && !isClinicThemeId(stored.id)) return;

      const settings = await this.getThemeSettings();
      if (!settings) return;

      if (readStoredTheme()) {
        this.resyncStoredClinicTheme(settings);
        return;
      }
      this.applyClinicDefaultTheme(settings);
    },
    resyncStoredClinicTheme(settings) {
      const { status, theme } = syncStoredClinicTheme(settings);
      if (status !== CLINIC_THEME_SYNC.UPDATED) return;
      applyTheme(theme);
      dispatchThemeChanged(theme.themeColor);
    },
    applyClinicDefaultTheme(settings) {
      const theme = activeTheme(settings);
      applyTheme(theme);
      dispatchThemeChanged(theme.themeColor);
    },
    openMobileSidebar() {
      this.sidebarMobileOpen = true;
    },
    closeMobileSidebar() {
      this.sidebarMobileOpen = false;
    },
  },
};
</script>
